/* MOBILE POLISH V1 */
(() => {
  function removeDuplicateArrows() {
    document.querySelectorAll("a").forEach(link => {
      link.childNodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE) {
          node.nodeValue = node.nodeValue.replace(
            /→(?:\s*→)+/g,
            "→"
          );
        }
      });

      const linkHasArrow = /→/.test(link.textContent || "");
      const afterContent = getComputedStyle(link, "::after").content || "";

      if (linkHasArrow && /→/.test(afterContent)) {
        link.classList.add("am-mobile-polish-no-after-arrow");
      }
    });
  }

  function addFamilySwipeCue() {
    document.querySelectorAll(".am-family-look__products").forEach(products => {
      const previous = products.previousElementSibling;

      if (previous?.classList.contains("am-family-look__swipe")) {
        return;
      }

      const cue = document.createElement("p");
      cue.className = "am-family-look__swipe";
      cue.textContent = "SWIPE TO EXPLORE →";
      cue.setAttribute("aria-hidden", "true");
      products.before(cue);
    });
  }

  function apply() {
    removeDuplicateArrows();
    addFamilySwipeCue();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", apply, { once: true });
  } else {
    apply();
  }

  window.setTimeout(apply, 500);
})();
